var identity = require('./identity');

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;



//////////////////
// WEBPACK FOOTER
// ./~/lodash/_castFunction.js
// module id = 1465
// module chunks = 0